import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { Box } from '@mui/material';
import { truncate } from 'lodash-es';
import PropTypes from 'prop-types';
import { PreviewFileWrapper, StyledFileBox, StyledCancelIcon } from './PreviewFile.styles.js';
const _excluded = ["files", "onDelete", "bigImg", "onImgClick", "white", "videoProps", "smallVideo", "iconColor", "fileNameColor", "extColor"];
function PreviewFile(_ref) {
  let {
      files,
      onDelete,
      bigImg,
      onImgClick,
      white,
      videoProps,
      smallVideo,
      iconColor,
      fileNameColor,
      extColor
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  function getNameAndExtension(file, isUrl) {
    const fullName = isUrl ? file.split('/').pop() : file.name;
    const lastIndex = fullName.lastIndexOf('.');
    const fileName = fullName.slice(0, lastIndex);
    const extension = fullName.slice(lastIndex + 1).toLowerCase();
    if (isUrl) {
      const videoExtensions = ['mp4', 'webm', 'ogg', 'flv', 'avi', 'mov'];
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'avif'];
      const fileExtensions = ['pdf'];
      const name = fileName.includes('-') ? fileName.split('-')[0] : fileName;
      if (fileExtensions.includes(extension)) return {
        name,
        extension,
        fileType: 'pdf'
      };
      if (videoExtensions.includes(extension)) return {
        name,
        extension,
        fileType: 'video'
      };
      if (imageExtensions.includes(extension)) return {
        name,
        extension,
        fileType: 'image'
      };
      return {
        name,
        extension,
        fileType: 'image'
      };
    }
    const fileType = file.type;
    if (fileType.includes('pdf')) return {
      name: fileName,
      extension,
      fileType: 'pdf'
    };
    if (fileType.includes('video')) return {
      name: fileName,
      extension,
      fileType: 'video'
    };
    if (fileType.includes('image')) return {
      name: fileName,
      extension,
      fileType: 'image'
    };
    return {
      name: fullName,
      extension,
      fileType: 'image'
    };
  }
  function handleOpenPdf(file) {
    if (typeof file !== 'string') return;
    const link = document.createElement('a');
    link.href = file;
    link.download = '';
    link.target = '_blank';
    link.click();
  }
  function handleOpenVideo(url) {
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.click();
  }
  const renderInfo = (name, extension) => /*#__PURE__*/React__default.createElement(Box, {
    fontSize: 12,
    ml: "8px"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: fileNameColor
    }
  }, truncate(name, {
    length: 13
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: extColor
    }
  }, extension.toUpperCase()));
  return /*#__PURE__*/React__default.createElement(PreviewFileWrapper, props, files === null || files === void 0 ? void 0 : files.map((fileItem, index) => {
    const isUrl = typeof fileItem === 'string';
    const {
      name,
      extension,
      fileType
    } = getNameAndExtension(fileItem, isUrl);
    return /*#__PURE__*/React__default.createElement("div", {
      key: name,
      style: {
        position: 'relative'
      }
    }, fileType === 'pdf' && /*#__PURE__*/React__default.createElement(StyledFileBox, {
      onClick: () => handleOpenPdf(fileItem)
    }, /*#__PURE__*/React__default.createElement(Box, {
      width: "30px",
      height: "30px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }, /*#__PURE__*/React__default.createElement("i", {
      className: "meta-crm-icon-ic_file_outline font-size-20",
      style: {
        color: iconColor,
        margin: ' 0 4px'
      }
    })), renderInfo(name, extension)), fileType === 'video' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, isUrl && !smallVideo ? /*#__PURE__*/React__default.createElement("video", _extends({
      controls: true,
      width: "306",
      controlsList: "nodownload",
      onContextMenu: "return false;"
    }, videoProps), /*#__PURE__*/React__default.createElement("source", {
      src: fileItem,
      type: "video/webm"
    }), /*#__PURE__*/React__default.createElement("source", {
      src: fileItem,
      type: "video/mp4"
    }), /*#__PURE__*/React__default.createElement("track", {
      kind: "captions"
    })) : /*#__PURE__*/React__default.createElement(StyledFileBox, {
      onClick: isUrl ? () => handleOpenVideo(fileItem) : null
    }, /*#__PURE__*/React__default.createElement(Box, {
      width: "30px",
      height: "30px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }, /*#__PURE__*/React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "18",
      height: "18",
      viewBox: "0 0 18 18",
      fill: "none"
    }, /*#__PURE__*/React__default.createElement("path", {
      d: "M15 2.25H3C2.17275 2.25 1.5 2.92275 1.5 3.75V14.25C1.5 15.0773 2.17275 15.75 3 15.75H15C15.8273 15.75 16.5 15.0773 16.5 14.25V3.75C16.5 2.92275 15.8273 2.25 15 2.25ZM15.0007 6.75C15 6.75 15 6.75 15.0007 6.75H14.652L12.6517 3.75H15L15.0007 6.75ZM7.152 6.75L5.15175 3.75H7.09875L9.099 6.75H7.152ZM10.902 6.75L8.90175 3.75H10.8488L12.849 6.75H10.902ZM3 3.75H3.34875L5.349 6.75H3V3.75ZM3 14.25V8.25H15L15.0015 14.25H3Z",
      fill: "#7B61FF"
    }), /*#__PURE__*/React__default.createElement("path", {
      d: "M7.5 13.5L11.625 11.25L7.5 9V13.5Z",
      fill: "#7B61FF"
    }))), renderInfo(name, extension))), fileType === 'image' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, bigImg ? /*#__PURE__*/React__default.createElement(StyledFileBox, {
      onClick: onImgClick ? () => onImgClick(fileItem) : null
    }, /*#__PURE__*/React__default.createElement("img", {
      src: isUrl ? fileItem : URL.createObjectURL(fileItem),
      alt: "",
      style: {
        width: '30px',
        height: '30px',
        display: 'block',
        borderRadius: '5px',
        cursor: onImgClick ? 'pointer' : 'default'
      }
    }), renderInfo(name, extension)) : /*#__PURE__*/React__default.createElement(Box, {
      onClick: onImgClick ? () => onImgClick(fileItem) : () => {},
      component: "img",
      src: isUrl ? fileItem : URL.createObjectURL(fileItem),
      alt: "",
      style: {
        width: '40px',
        height: '40px',
        display: 'block',
        borderRadius: '5px',
        cursor: onImgClick ? 'pointer' : 'default'
      }
    })), onDelete ? /*#__PURE__*/React__default.createElement(StyledCancelIcon, {
      onClick: () => onDelete(fileItem, index)
    }, /*#__PURE__*/React__default.createElement("i", {
      className: "meta-crm-icon-ic_x_circle font-size-12"
    })) : null);
  }));
}
PreviewFile.propTypes = {
  files: PropTypes.arrayOf(PropTypes.shape({})),
  onDelete: PropTypes.func,
  bigImg: PropTypes.bool,
  onImgClick: PropTypes.func,
  white: PropTypes.bool,
  videoProps: PropTypes.shape({}),
  smallVideo: PropTypes.bool,
  iconColor: PropTypes.string,
  extColor: PropTypes.string,
  fileNameColor: PropTypes.string
};
PreviewFile.defaultProps = {
  files: [],
  onDelete: null,
  bigImg: true,
  onImgClick: null,
  white: null,
  videoProps: {},
  smallVideo: false,
  iconColor: '#7B61FF',
  extColor: '#A5A5A5',
  fileNameColor: '#555'
};
export { PreviewFile as default };